// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ff486c9","453":"374d0d1e","455":"b68db330"}[chunkId] + ".chunk.js";
};